module.exports = __webpack_public_path__ + "static/media/FEDERMOBILE.e69ba09f.svg";